export default {"src":"/_next/static/media/android.3014ffbe.svg","height":22,"width":38,"blurWidth":0,"blurHeight":0};